import { ApolloProvider } from '@apollo/client'
import { BrowserRouter, MemoryRouter } from 'react-router-dom'
import { Wrapper } from '../wrapper'
import { createApolloClient } from '../apollo/create-apollo-client'

const apolloClient = createApolloClient()

const isEmbedded = /\/embedded$/.test(window.location.pathname)
const Router = isEmbedded ? MemoryRouter : BrowserRouter

export const withAppContext = (app) => (
  <Wrapper>
    <ApolloProvider client={apolloClient}>
      <Router {...(isEmbedded ? { initialEntries: ['/embedded'], initialIndex: 1 } : {})}>{app}</Router>
    </ApolloProvider>
  </Wrapper>
)
